export function menuHandler(menuBoxStyle: string, setMenuBoxStyle: React.Dispatch<React.SetStateAction<string>>, menuBoxSize: string, setMenuBoxSize: React.Dispatch<React.SetStateAction<string>>) {
    if (menuBoxStyle === "max-lg:hidden") {
        setMenuBoxStyle("max-lg:block");
        setMenuBoxSize("100%");
    } else {
        setMenuBoxStyle("max-lg:hidden");
        setMenuBoxSize("360");
    }
}